import { Injectable } from '@angular/core';
import {
  DeviceStatusReportClient,
  DeviceStatusReportParameterDTO,
  FilterDTO,
  FilterOperator,
  PagedResultDTOOfDeviceStatusReportDTO,
  PagedResultDTOOfZoneDTO,
  SavedReportFileDTO,
  SortDirection,
  ZoneClient,
} from '../../../../base/models/models.swagger.generated';
import { ClientService } from '../../../../base/services/client/client.service';
import { catchError, tap } from 'rxjs/operators';
import { ErrorType } from '../../../../core/routing/error-types';
import { Observable, throwError } from 'rxjs';
import { ToastService } from '../../../../base/services/toast.service';
import { SaveOptions } from '../../reports-footer/save-options';
import { ShowInactiveService } from '../../../../base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from '../../../../base/shared/syncfusion/adaptor-service.interface';

@Injectable()
export class DeviceStatusReportService extends ShowInactiveService implements IAdaptorService {

  public filters: FilterDTO[] = [];
  public deviceIpAddresses = new Map<number, string>();

  constructor(private deviceStatusReportClient: DeviceStatusReportClient,
              private zoneClient: ZoneClient,
              private clientService: ClientService,
              private toastService: ToastService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfDeviceStatusReportDTO> {
    if (!filters) {
      filters = [];
    }
    filters = [...filters, ...this.filters];
    if (!sortBy) {
      sortBy = 'Id';
    }
    if (!sortDirection) {
      sortDirection = SortDirection.Ascending;
    }
    return this.deviceStatusReportClient.searchDeviceStatusReportData(this.clientService.selectedClient.id, filters, skip, take, sortBy, sortDirection, true)
      .pipe(
        tap(result => {
          this.deviceIpAddresses.clear();
          const devices = result.items;
          devices.forEach(device => {
            let ipAddress = '';
            // device parameters are not strongly typed, so fields cannot be accessed by dot annotation
            // eslint-disable-next-line @typescript-eslint/dot-notation
            const ipAddressParam = device.device.parameters?.find(parameter => parameter['configuration'].ident.includes('IPAddress'));
            if (ipAddressParam) {
              // eslint-disable-next-line @typescript-eslint/dot-notation
              ipAddress = ipAddressParam['value'];
            }
            this.deviceIpAddresses.set(device.device.id, ipAddress);
          });
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public exportReport(deviceStatusReportParameterDTO: DeviceStatusReportParameterDTO, saveOptions: SaveOptions): Observable<SavedReportFileDTO> {
    return this.deviceStatusReportClient.exportDeviceStatusReport(
      this.clientService.selectedClient.id,
      saveOptions.exportType,
      saveOptions.saveReport,
      deviceStatusReportParameterDTO
    )
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public searchZones(searchText: string): Observable<PagedResultDTOOfZoneDTO> {
    const filterDTOs = [];
    filterDTOs.push(new FilterDTO({
      isComplex: false,
      field: 'Name',
      operator: FilterOperator.Contains,
      value: searchText,
    }));
    return this.zoneClient.searchZones(this.clientService.selectedClient.id, filterDTOs, 0, 9, 'Name', SortDirection.Ascending)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

}
